module.exports = __webpack_public_path__ + "img/villa1.4e352172.jpg";